import { COLOR_BLACK } from "helpers/colors";
import useFullscreenState from "helpers/useFullscreenState";
import useMobileLayout from "helpers/useMobileLayout";
import Dialog from "molecules/Dialog";
import React from "react";

// The black dialog the highlight, reel and Top 5 players open in.
// On mobile it fills the screen, with the dialog's X in the corner instead of the players' close pill.
export default function VideoPlayerDialog({ open, onClose, PaperProps, children }) {
  const [fullscreen] = useFullscreenState();
  const mobileLayout = useMobileLayout();

  return (
    <Dialog
      noPadding
      hideCloseButton={!mobileLayout}
      open={open}
      onClose={onClose}
      inverse
      {...(mobileLayout && { fullScreen: true })}
      {...(fullscreen
        ? { fullHeight: true, fullWidth: true }
        : {
            mediumWidth: true,
          })}
      PaperProps={{
        ...PaperProps,
        style: {
          backgroundColor: COLOR_BLACK,
          ...PaperProps?.style,
        },
      }}
    >
      {children}
    </Dialog>
  );
}
